<template>
<div class="outsideBox">
   <div class="w" ref="w">
    <div class="cockpit" ref="cockpit">
      <img class="i0" src="@/assets/images/newIcon/bi_middle_bg.png" alt="" />
      <div class="rotateMap">
        <img class="i1" src="@/assets/images/newIcon/map.png" alt="" />
        <img
          ref="i2"
          class="i2"
          src="@/assets/images/newIcon/quan.png"
          alt=""
        />
      </div>
      <!-- 标题区 -->
      <div class="title">
        <div class="left">
          <img class="i1" src="@/assets/images/newIcon/bi_logo.png" alt="" />
          <span class="s1">积木云BI驾驶舱</span>
          <img class="i2" src="@/assets/images/newIcon/bi_sx_icon.png" alt="" />
          <span class="yewu">
            <span>业务系统</span>
            <img
              style="width: 16px; height: 16px; margin-left: 10px"
              src="@/assets/images/newIcon/bi_updown_icon.png"
              alt=""
            />
          </span>
          <span class="updown">
            <img
              v-if="checkm"
              @click="down"
              src="@/assets/images/newIcon/bi_sq_icon.png"
              alt=""
            />
            <img
              v-if="!checkm"
              @click="up"
              src="@/assets/images/newIcon/bi_zk_icon.png"
              alt=""
            />
          </span>
        </div>
        <div class="right">
          <span class="s1">{{ year }}.{{ month }}.{{ date }}</span>
          <span style="margin-left: 5px" class="s2">{{ getWeek }}</span>
          <span class="s3">{{ hh }}:{{ mm }}:{{ ss }}</span>
          <img
            style="margin-left: 15px"
            src="@/assets/images/newIcon/tianqi_icon.png"
            alt=""
          />
        </div>
      </div>
      <!-- 关键指标 -->
      <div class="KeyIndicators">
        <p class="p1">
          <span>关键指标</span
          ><span style="margin-left: 10px">Key Indicators</span>
        </p>
        <ul class="ul1">
          <li>
            <p class="ul1_p1">今日累计访问</p>
            <p class="ul1_p2">
              <span class="s1">583903</span><span class="s2">次</span>
            </p>
          </li>
          <li>
            <p class="ul1_p1">今日访问次数</p>
            <p class="ul1_p2">
              <span class="s1">583903</span><span class="s2">人</span>
            </p>
          </li>
          <li>
            <p class="ul1_p1" style="transform: translate(-15px, 0px)">
              实时访客
            </p>
            <p class="ul1_p2">
              <span class="s1">583903</span><span class="s2">次</span>
            </p>
          </li>
          <li>
            <p class="ul1_p1" style="transform: translate(-15px, 0px)">
              实名用户
            </p>
            <p class="ul1_p2">
              <span class="s1">583903</span><span class="s2">人</span>
            </p>
          </li>
          <li>
            <p class="ul1_p1">今日新增用户</p>
            <p class="ul1_p2">
              <span class="s1">583903</span><span class="s2">人</span>
            </p>
          </li>
        </ul>
      </div>
      <!-- 表格区域 -->
      <div class="chartsData">
        <div class="l">
          <div class="l_t">
            <h3><span>渠道来源 </span><span> Channel Source</span></h3>
            <!-- 表格1 -->
            <div class="my_table">
              <el-table
                ref="table"
                :header-cell-style="{
                  background: '#032957',
                  color: '#333333',
                  border: 'none',
                }"
                :data="tableData"
                style="width: 100%"
              >
                <el-table-column prop="d1" label="渠道名称" width="100">
                </el-table-column>
                <el-table-column prop="d2" label="访问数量"> </el-table-column>
                <el-table-column
                  prop="d3"
                  label="新客数量"
                  width="100"
                ></el-table-column>
              </el-table>
            </div>
          </div>
          <div class="l_b">
            <!-- 条形图 -->
            <h3><span>关键页面访问次数</span><span> Key Page Visits</span></h3>
            <div id="b1" class="bar"></div>
          </div>
        </div>
        <div class="c">
          <div class="c_b">
            <h3>
              <span>平台流量分布</span
              ><span> Platform Traffic Distribution</span>
            </h3>
            <!-- 饼图 -->
            <div id="c1" class="picMap"></div>
          </div>
        </div>
        <div class="r">
          <div class="r_t">
            <h3><span>实时行为</span><span> Real Time Behavior</span></h3>
            <!-- 表格2 -->
            <div class="my_table">
              <el-table
                ref="table2"
                :header-cell-style="{
                  background: '#032957',
                  color: '#333333',
                  border: 'none',
                }"
                :data="tableData2"
                style="width: 100%"
              >
                <el-table-column prop="d1" label="用户名" width="100">
                </el-table-column>
                <el-table-column prop="d2" label="关键行为"> </el-table-column>
                <el-table-column
                  prop="d3"
                  label="触发时间"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="d4"
                  label="来源渠道"
                  width="100"
                ></el-table-column>
              </el-table>
            </div>
          </div>
          <div class="r_b">
            <h3>
              <span>销售实时看板</span><span> Salas Real-Time Kanban</span>
            </h3>
            <!-- 表格3 -->
            <div class="my_table">
              <el-table
                ref="table3"
                :header-cell-style="{
                  background: '#032957',
                  color: '#333333',
                  border: 'none',
                }"
                :data="tableData3"
                style="width: 100%"
              >
                <el-table-column prop="d1" label="用户名" width="100">
                </el-table-column>
                <el-table-column prop="d2" label="支付商品"> </el-table-column>
                <el-table-column
                  prop="d3"
                  label="支付时间"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="d4"
                  label="订单金额"
                  width="100"
                ></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
 
  
</template>
<script>
import * as echarts from "echarts";
import { Scale } from "@antv/scale";
let time1 = null;
let time2 = null;
let time3 = null;
let time4 = null;
let time5 = null;
let time6 = null;
export default {
  data() {
    return {
      checkm: true,
      //表格数据
      tableData: [
        {
          d1: "微信渠道",
          d2: "1000",
          d3: "1000",
        },
        {
          d1: "APP渠道",
          d2: "1000",
          d3: "1000",
        },
        {
          d1: "自定义渠道1",
          d2: "1000",
          d3: "1000",
        },
        {
          d1: "自定义渠道2",
          d2: "1000",
          d3: "1000",
        },
        {
          d1: "自定义渠道3",
          d2: "1000",
          d3: "1000",
        },
        {
          d1: "自定义渠道4",
          d2: "1000",
          d3: "1000",
        },
        {
          d1: "自定义渠道5",
          d2: "1000",
          d3: "1000",
        },
        {
          d1: "自定义渠道6",
          d2: "1000",
          d3: "1000",
        },
        {
          d1: "自定义渠道7",
          d2: "1000",
          d3: "1000",
        },
        {
          d1: "自定义渠道8",
          d2: "1000",
          d3: "1000",
        },
      ],
      tableData2: [
        {
          d1: "吴彦祖",
          d2: "转发订单",
          d3: "22:10:30",
          d4: "渠道一",
        },
        {
          d1: "吴彦祖",
          d2: "取消订单",
          d3: "22:10:30",
          d4: "渠道一",
        },
        {
          d1: "吴彦祖",
          d2: "支付订单",
          d3: "22:10:30",
          d4: "渠道一",
        },
        {
          d1: "吴彦祖",
          d2: "登录系统",
          d3: "22:10:30",
          d4: "渠道一",
        },
        {
          d1: "吴彦祖",
          d2: "转发订单",
          d3: "22:10:30",
          d4: "渠道一",
        },
        {
          d1: "吴彦祖",
          d2: "取消订单",
          d3: "22:10:30",
          d4: "渠道一",
        },
        {
          d1: "吴彦祖",
          d2: "支付订单",
          d3: "22:10:30",
          d4: "渠道一",
        },
        {
          d1: "吴彦祖",
          d2: "登录系统",
          d3: "22:10:30",
          d4: "渠道一",
        },
        {
          d1: "吴彦祖",
          d2: "转发订单",
          d3: "22:10:30",
          d4: "渠道一",
        },
        {
          d1: "吴彦祖",
          d2: "取消订单",
          d3: "22:10:30",
          d4: "渠道一",
        },
      ],
      tableData3: [
        {
          d1: "吴彦祖",
          d2: "Yeazy 350 v2",
          d3: "22:10:30",
          d4: "29000",
        },
        {
          d1: "吴彦祖",
          d2: "Yeazy 350 v2",
          d3: "22:10:30",
          d4: "1000",
        },
        {
          d1: "吴彦祖",
          d2: "Yeazy 350 v2",
          d3: "22:10:30",
          d4: "1000",
        },
        {
          d1: "吴彦祖",
          d2: "Yeazy 350 v2",
          d3: "22:10:30",
          d4: "1000",
        },
        {
          d1: "吴彦祖",
          d2: "Yeazy 350 v2",
          d3: "22:10:30",
          d4: "1000",
        },
        {
          d1: "吴彦祖",
          d2: "Yeazy 350 v2",
          d3: "22:10:30",
          d4: "1000",
        },
        {
          d1: "吴彦祖",
          d2: "Yeazy 350 v2",
          d3: "22:10:30",
          d4: "1000",
        },
        {
          d1: "吴彦祖",
          d2: "Yeazy 350 v2",
          d3: "22:10:30",
          d4: "1000",
        },
        {
          d1: "吴彦祖",
          d2: "Yeazy 350 v2",
          d3: "22:10:30",
          d4: "1000",
        },
        {
          d1: "吴彦祖",
          d2: "Yeazy 350 v2",
          d3: "22:10:30",
          d4: "1000",
        },
      ],
      //时间
      year: "",
      month: "",
      date: "",
      getWeek: "",
      hh: "",
      mm: "",
      ss: "",
      //下拉选项
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
      ],
      value: "",
      chooseEquipment: "",
    };
  },
  mounted() {
    // this.$refs.w.style.width = 1920 * window.innerHeight / 1080 +'px'
    // window.onresize = ()=>{ //改变可视区域触发
    //     // location=location; //页面刷新
    //     let w = document.body.clientWidth
    //     let h = document.body.clientHeight
    //     console.log('heioght',document.body.clientHeight);
    //    this.$refs.cockpit.style.transform = `scaleX(${w/1600})`
    //    this.$refs.cockpit.style.transform = `scaleY(${h/1000})`
    //     console.log('transform',this.$refs.cockpit.style.zoom);
    // },
    setTimeout(() => {
      document.getElementsByClassName("top-menu")["0"].style.display = "none";
    }, 200);
    this.nowTimes();
    this.myscroll();
    this.init(); //条形图
    this.rotate(); //旋转事件
    this.init2(); //饼图
  },
  beforeDestroy() {
    clearTimeout(time1);
    clearTimeout(time2);
    clearTimeout(time3);
    clearTimeout(time4);
  },
  created(){
    this.test()
  },
  methods: {
    test(){
    //  setTimeout(()=>{
    //     window.addEventListener("resize",  ()=>{
    //   this.$refs.w.style.width = 1620 * (window.innerHeight / 937) +'px'
    //   this.$refs.w.style.height = window.innerHeight + 'px'
    //   this.$refs.cockpit.style.transform = `scale(${window.innerHeight / 937} , ${window.innerHeight / 937})`
    // });
    // this.$router.go(0)
    //  },200)
    },
    //切换顶部
    down() {
      window.document.getElementsByClassName("top-menu")["0"].style.display =
        "block";
      this.checkm = false;
    },
    up() {
      document.getElementsByClassName("top-menu")["0"].style.display = "none";
      this.checkm = true;
    },

    //饼图
    init2() {
      var chartDom = document.getElementById("c1");
      var myChart = echarts.init(chartDom);
      var option;
      let obj = this;
      option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical", //设置图例的方向
          right: 20,
          top: "center",
          itemWidth: 15,
          itemHeight: 15,
          itemGap: 10, //设置图例的间距
          textStyle: {
            //图例文字的样式
            color: "#b4b9c8",
            fontSize: 12,
          },
        },
        series: [
          {
            name: "流量分布",
            type: "pie",
            //颜色渐变
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = [
                    ["#2DEAF8", "#149CDC"],
                    ["#8121D7", "#B745ED"],
                    ["#280AEA", "#5319FB"],
                    ["#1074F8", "#058FE0"],
                  ];
                  var colorItem = colorList[params.dataIndex];
                  return new echarts.graphic.LinearGradient(
                    1,
                    0,
                    0,
                    0,
                    [
                      {
                        offset: 0,
                        color: colorItem[0],
                      },
                      {
                        offset: 1,
                        color: colorItem[1],
                      },
                    ],
                    false
                  );
                },
              },
            },

            radius: ["50%", "80%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold",
                color: "#cbcdd9",
                formatter: ["{d}%", "{b|{b}}"].join("\n"),
                rich: {
                  a: {
                    // 中间字的数值样式
                    color: "#d8dae2",
                    fontSize: 32,
                    lineHeight: 40,
                    verticalAlign: "bottom",
                  },
                  b: {
                    // 中间字的名称样式
                    color: "#fff",
                    fontSize: "60%",
                    lineHeight: 24,
                  },
                },
              },
            },
            labelLine: {
              show: true,
            },
            data: [
              { value: 1048, name: "网页" },
              { value: 735, name: "安卓" },
              { value: 580, name: "小程序" },
              { value: 484, name: "IOS" },
            ],
          },
        ],
      };
      option && myChart.setOption(option);
      let index = -1; //高亮所在下标
      time1 = setInterval(() => {
        myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0, //里层的圆形
          dataIndex: index,
        });
        index++;
        if (index > 3) {
          index = 0;
        }
        myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: index,
        });
      }, 2000);
    },
    //旋转图片
    rotate() {
      let size = 0;
      time2 = setInterval(() => {
        if (size > 360) {
          size = -360;
        }
        size++;
        this.$refs.i2.style.transform =
          "rotateX(38deg) rotateY(38deg) rotateZ(" + size + "deg)";
      }, 5);
    },
    //条形图
    init() {
      var chartDom = document.getElementById("b1");
      var myChart = echarts.init(chartDom);
      var option;

      const data = [];
      for (let i = 0; i < 5; ++i) {
        data.push(Math.round(Math.random() * 200));
      }
      option = {
        xAxis: {
          max: "dataMax",
          //是否显示x轴
          show: false,
        },
        yAxis: {
          type: "category",
          data: ["页面一", "页面二", "页面三", "页面四", "页面五"],
          inverse: true,
          animationDuration: 200,
          animationDurationUpdate: 200,
          max: 4, // only the largest 3 bars will be displayed
          axisLabel: {
            margin: 10,
            color: "#989caa",
            fontSize: 12,
          },
          boundaryGap: [0.4, 0.4],
        },
        grid: {
          left: "0%",
          right: "13%",
          bottom: "0%",
          containLabel: true,
        },
        series: [
          {
            realtimeSort: true,
            name: "X",
            type: "bar",
            barWidth: 15, //设置柱子的宽度

            //柱体渐变
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = [
                    ["#206FFF", "#351FFF"],
                    ["#5D95FB", "#663DE8"],
                    ["#7FD8FF", "#2AE1F5"],
                    ["#FFE8A2", "#F9BB02"],
                    ["#77A3FF", "#3F76FE"],
                  ];
                  var colorItem = colorList[params.dataIndex];
                  return new echarts.graphic.LinearGradient(
                    1,
                    0,
                    0,
                    0,
                    [
                      {
                        offset: 0,
                        color: colorItem[0],
                      },
                      {
                        offset: 1,
                        color: colorItem[1],
                      },
                    ],
                    false
                  );
                },
              },
            },

            data: data,
            label: {
              show: true,
              position: "right",
              valueAnimation: true,
            },
            label: {
              show: true,
              formatter: function (params) {
                return params.value + "人";
              },
              position: "right",
              offset: [0, 0],
              color: "#676e85",
              fontSize: 12,
            },
          },
        ],
        legend: {
          show: false,
        },
        animationDuration: 0,
        animationDurationUpdate: 3000,
        animationEasing: "linear",
        animationEasingUpdate: "linear",
      };
      function run() {
        for (var i = 0; i < data.length; ++i) {
          if (Math.random() > 0.9) {
            data[i] += Math.round(Math.random() * 1000);
          } else {
            data[i] += Math.round(Math.random() * 100);
          }
        }
        myChart.setOption({
          series: [
            {
              type: "bar",
              data,
            },
          ],
        });
      }
      setTimeout(function () {
        run();
      }, 1000);
      setInterval(function () {
        run();
      }, 3000);

      option && myChart.setOption(option);
    },
    //表格移动
    myscroll() {
      let size = 0;
      time3 = setInterval(() => {
        if (size < 300) {
          size += 0.1;
          this.$refs.table.$refs.bodyWrapper.style.marginTop =
            "-" + size + "px";
          this.$refs.table2.$refs.bodyWrapper.style.marginTop =
            "-" + size + "px";
          this.$refs.table3.$refs.bodyWrapper.style.marginTop =
            "-" + size + "px";
        } else {
          size = 0;
          this.$refs.table.$refs.bodyWrapper.style.marginTop =
            "-" + size + "px";
          this.$refs.table2.$refs.bodyWrapper.style.marginTop =
            "-" + size + "px";
          this.$refs.table3.$refs.bodyWrapper.style.marginTop =
            "-" + size + "px";
        }
      }, 1);
    },
    //显示当前时间（年月日时分秒）
    timeFormate(timeStamp) {
      this.year = new Date(timeStamp).getFullYear();
      this.month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      this.date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      this.hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      this.mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      this.ss =
        new Date(timeStamp).getSeconds() < 10
          ? "0" + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
      let week = new Date(timeStamp).getDay();
      let weeks = ["日", "一", "二", "三", "四", "五", "六"];
      this.getWeek = "星期" + weeks[week];
      //   this.nowTime = year + "年" + month + "月" + date +"日"+" "+hh+":"+mm+':'+ss+getWeek  ;
    },
    nowTimes() {
      this.timeFormate(new Date());
      setInterval(this.nowTimes, 1000);
      this.clear();
    },
    clear() {
      clearInterval(this.nowTimes);
      this.nowTimes = null;
    },
  },
};
</script>
<style lang="less" scoped>
// .outsideBox{
//   width: 100vw;
//   height: 100vh;
//    background: linear-gradient(90deg, #00083d 0%, #00031b 100%);
//    box-sizing: border-box;
// }
// .w {
//   background:transparent;
//   // overflow: hidden;
//   width: 1200px;
//   box-sizing: border-box;
//   position: relative;
// }
.cockpit {
//   position:absolute;
// left:0;
// top:0;
  overflow: hidden;
  width: 100%;
  height: 100%; //calc(100vh - 58px)
  // width: 1620px;
  // height: 937px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #00083d 0%, #00031b 100%);
  background: url(~@/assets/images/newIcon/bi_bg.png) no-repeat;
  background-size: 100% 100%;
  transition: all .3s linear;
  // transform: scale(1);
  .i0 {
    position: absolute;
    top: 300px;
    left: 500px;
    width: 1000px;
  }
  .rotateMap {
    top: 0px;
    left: 100px;
    .i1 {
      position: absolute;
      width: 400px;
      height: 400px;
      top: 20%;
      left: 50%;
      margin-left: -200px;
    }
    .i2 {
      position: absolute;
      width: 400px;
      top: 25%;
      left: 50%;
      margin-left: -200px;
      transform: rotateX(38deg) rotateY(38deg);
    }
  }
  //顶部
  .title {
    width: 100%;
    height: 10vh;
    position: relative;
    .left {
      display: flex;
      align-items: center;
      margin-left: 3%;
      transform: translate(0, 10px);
      .yewu {
        display: inline-block;
        width: 6.5%;
        height: 36px;
        background: linear-gradient(
          180deg,
          rgba(26, 89, 251, 0.2) 0%,
          rgba(27, 101, 252, 0.25) 100%
        );
        border-radius: 6px;
        opacity: 0.47;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 1%;
        margin-top: .3%;
      }
      .i1 {
        width: 42px;
        height: 44px;
      }
      .s1 {
        margin-left: 1%;
        font-size: 30px;
        font-family: HYk1gj;
        color: #ffffff;
      }
      .i2 {
        margin-top: 10px;
        margin-left: 14px;
        margin-right: 6px;
        width: 26px;
        height: 26px;
      }
      /deep/ .el-input__inner {
        margin-top: 10px;
        width: 120px;
        height: 36px;
        background: linear-gradient(
          180deg,
          rgba(26, 89, 251, 0.2) 0%,
          rgba(27, 101, 252, 0.25) 100%
        );
        border: 2px solid #142859;
      }
    }
    .right {
      color: #fff;
      position: absolute;
      right: 10px;
      top: 20px;
      display: flex;
      align-items: center;
      .s1 {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3582eb;
      }
      .s2 {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3582eb;
      }
      .s3 {
        margin-left: 20px;
        font-size: 28px;
        font-family: HYk1gj;
        color: #ffffff;
      }
    }
    // background-color: red;
    .updown {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      justify-content: center;
    }
  }
  //中间
  .KeyIndicators {
    width: 100%;
    // height: 20vh;
    > .p1 {
      width: 96.5%;
      height: 35px;
      background: url(~@/assets/images/newIcon/bi_title_bg.png) no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 35px;
      padding: 0px 15px;
    }
    .ul1 {
      box-sizing: border-box;
      width: 90%;
      height: 132px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      li {
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .ul1_p1 {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(234, 234, 234, 0.85);
          margin-left: -80px;
          margin-top: -10px;
        }
        .ul1_p2 {
          margin-top: 10px;
          .s1 {
            font-size: 42px;
            font-family: DINPro-Black, DINPro;
            font-weight: 900;
            color: #39c0fd;
          }
          .s2 {
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #39c0fd;
            margin-left: 10px;
          }
        }
        &:nth-child(1) {
          background: url(~@/assets/images/newIcon/bi_xz_bg.png) no-repeat;
          background-size: 100% 100%;
          .s1 {
            color: #fff;
          }
          .s2 {
            color: #fff;
          }
        }
      }
    }
    // background-color: yellow;
  }
  //底部
  .chartsData {
    width: 100%;
    height: 65.8vh;
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    h3 {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      margin-left: 15px;
      padding-top: 15px;
      margin-bottom: 10px;
    }
    //表格样式
    .my_table {
      overflow: hidden;
      height: 70%;
    
      padding: 15px;
      /deep/ .el-table {
        border: none;
      }
      /deep/ .el-table__header-wrapper {
        position: relative;
        z-index: 100;
      }
      /deep/ .cell {
        text-align: center;
        background-color: transparent;
        color: #fff;
        font-size: 12px;
      }
      /deep/ .el-table__row {
        background-color: #051844;
      }
      /deep/ .el-table__row:hover > td {
        background-color: #051844 !important;
      }

      /deep/ .el-table__row--striped:hover > td {
        background-color: #051844 !important;
      }
      /deep/ .el-table,
      .el-table__expanded-cell {
        background-color: transparent;
      }
      /deep/ .el-table td,
      .el-table th.is-leaf {
        border-bottom: 1px solid #1a244aff;
      }
      /deep/ .el-table--border::after,
      .el-table--group::after,
      .el-table::before {
        content: none;
      }
    }
    .l {
      width: 28%;
      height: 100%;
      box-sizing: border-box;
      .l_t {
        width: 100%;
        height: 48%;
        background: url(~@/assets/images/newIcon/bi_data_bg.png) no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
      }
      .l_b {
        margin-top: 20px;
        width: 100%;
        height: 48%;
        background: url(~@/assets/images/newIcon/bi_data_bg.png) no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        position: relative;

        .bar {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 20px;
        }
      }
    }
    .c {
      width: 40%;
      height: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: flex-end;
      .c_b {
        width: 100%;
        height: 48%;
        background: url(~@/assets/images/newIcon/bi_data_bg.png) no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        position: relative;
        .picMap {
          width: 100%;
          height: 82%;
        }
      }
    }
    .r {
      width: 28%;
      height: 100%;
      box-sizing: border-box;
      .r_t {
        width: 100%;
        height: 48%;
        background: url(~@/assets/images/newIcon/bi_data_bg.png) no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
      }
      .r_b {
        margin-top: 20px;
        width: 100%;
        height: 48%;
        background: url(~@/assets/images/newIcon/bi_data_bg.png) no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
      }
    }
  }
}
</style>